module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "in-out",
      "enter-active-class": "fadeInDown",
      "leave-active-class": "fadeOutUp",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.hide(5000)
      }
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "animated message-box"
  }, [_c('article', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(this.$store.state.error.name) + "!")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        _vm.hide(0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n        " + _vm._s(this.$store.state.error.response ? this.$store.state.error.response.data.error.message : this.$store.state.error.message) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6284485d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ErrorBubble.vue
// module id = 213
// module chunks = 1